import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { WsContacto, IWsContacto, WsCliente } from '@ciptech/classes';
import { ApiResponse, UsuarioSelectDto, ClienteDto, UsuarioContCliSimpleDto, GuardadoUsuarioDto, UsuarioContCliAdmDto, GuardarUsuarioByAdminDto } from '../dto';
import { handleApiError, normalizeHttpError } from '../utils';

@Injectable()
export class WsContactoService {

	private endpoint = `/api/WsContactos`;

	constructor(private http: HttpClient) { }

	get(IdUsuario: number): Observable<ApiResponse<UsuarioSelectDto>> {
		const headers = { context: '.wk-user' };

		return this.http.get<ApiResponse<UsuarioSelectDto>>(
			`${this.endpoint}/${IdUsuario}`,
			{ headers }
		).pipe(
			catchError(handleApiError<UsuarioSelectDto>())
		);
	}

	getAll(start: string, end: string): Observable<ApiResponse<WsContacto[]>> {
		return this.http.get<ApiResponse<IWsContacto[]>>(`${this.endpoint}?start=${start}&end=${end}`, { headers: { context: '.wk-user' } })
			.pipe(
				map(res => {
					let data = !res.Success || !res.Data ? [] : res.Data.map(item => new WsContacto(item));
					return {
						Success: res.Success,
						Message: res.Message,
						Data: data
					};
				}),
				catchError(handleApiError<WsContacto[]>())
			);
	}

	getUsuarioByFechas(start: string, end: string): Observable<ApiResponse<UsuarioSelectDto[]>> {
		return this.http.get<ApiResponse<UsuarioSelectDto[]>>(`${this.endpoint}?start=${start}&end=${end}`, { headers: { context: '.wk-user' } })
			.pipe(
				catchError(handleApiError<UsuarioSelectDto[]>())
			);
	}

	update(contacto: UsuarioContCliSimpleDto, cliente?: ClienteDto, context?): Observable<ApiResponse<string>> {

		const body: GuardadoUsuarioDto = {
			Contacto: contacto,
			Cliente: cliente
		}

		return this.http.post<ApiResponse<string>>(`${this.endpoint}/update`, body, { headers: { context: context || 'body' } }).pipe(
			catchError(handleApiError<string>())
		);
	}

	updateByAdm(contacto: UsuarioContCliAdmDto, cliente?: ClienteDto, context?): Observable<ApiResponse<string>> {
		const body: GuardarUsuarioByAdminDto = {
			Contacto: contacto,
			Cliente: cliente
		}
		return this.http.post<ApiResponse<string>>(`${this.endpoint}/update/adm`, body, { headers: { context: context || 'body' } }).pipe(
			catchError(handleApiError<string>())
		);
	}

	saveAvatar(file, context?): Observable<any> {
		const formData = new FormData();
		formData.append('avatar', file);
		return this.http.post<number>(`${this.endpoint}/avatar`, formData, { headers: { context: context || 'body' } });
	}

	deleteAvatar(context?): Observable<any> {
		return this.http.delete(`${this.endpoint}/avatar`, { headers: { context: context || 'body', caption: ' ' } });
	}

	changePassword(Password: string): Observable<ApiResponse<string>> {
		// const IdContacto = this.session.user.userId;
		const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
		return this.http.post<ApiResponse<string>>(`${this.endpoint}/change-password`, `=${Password}`, { headers }).pipe(
			catchError(handleApiError<string>())
		);
	}

	direcciones(): Observable<any> {
		const headers = { context: '.tab-content' };
		return this.http.get(`${this.endpoint}/direcciones`, { headers });
	}

	insertarDireccion(body) {
		const headers = { context: '.tab-content' };
		return this.http.post(`${this.endpoint}/direcciones`, body, { headers });
	}

	eliminarDireccion(IdDireccion) {
		const headers = { context: '.tab-content' };
		return this.http.delete(`${this.endpoint}/direcciones/eliminar/${IdDireccion}`, { headers });
	}

	crearValidacion(email) {
		const headers = { context: '.modal-body' };
		return this.http.post<ApiResponse<string>>(`${this.endpoint}/notificar-validacion`, email, { headers }).pipe(
			catchError(handleApiError<string>())
		);
	}

	validarCuenta(codigo) {
		const headers = { context: '.modal-body' };
		return this.http.get<ApiResponse<boolean>>(`${this.endpoint}/validar-cuenta/${codigo}`, { headers }).pipe(
			catchError(handleApiError<boolean>())
		);
	}

}
